import React from 'react';
import { ImageCellProps } from './image-cell.types';
import { useVehileLogo } from '../../../../hooks/react-query/vehile-logo';
import { SkeletonComponent } from '../../../skeleton/skeleton';

const ImageCell = ({ row }: ImageCellProps) => {
  const { data: img, isFetched: imgIsFetched } = useVehileLogo(
    row?.sharepointLocation || '',
    '/assets/images/vehicle-placeholders/PKW_small.svg'
  );

  return (
    <div style={{ height: '60px', width: '90px' }}>
      {imgIsFetched ? (
        <img src={img} alt={`Foto - ${row?.uds_title}`} />
      ) : (
        <SkeletonComponent width='100%' height='60px' />
      )}
    </div>
  );
};

export default ImageCell;
